// METIS Hub wording — namespace "home" (ko), 240 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/home.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const home: Record<string, string> = {
  "home.kicker.me": "내 사용",
  "home.kicker.team": "우리 팀 · {team}",
  "home.kicker.all": "회사 전체",
  "home.kicker.allTeam": "전체 · {team}만",
  "home.title.me": "{p} 나의 AI 사용",
  "home.title.team": "{team} {p} AI 사용",
  "home.title.all": "회사 전체 {p} AI 사용",
  "home.title.allTeam": "{team} {p} AI 사용",
  "home.title.ops": "{p} 수집 운영 현황",
  "home.title.audit": "{p} 열람·변경 점검",
  "home.desc": "{range} · 한국 시간 · 기준 {asof}",
  "home.q.team": "우리 팀은 AI를 얼마나, 어떻게 쓰고 있나요?",
  "home.q.all": "회사는 AI를 얼마나 쓰고 있고, 평소와 다른 곳은 없나요?",
  "home.q.ops": "기록이 빠짐없이 잘 들어오고 있나요?",
  "home.q.audit": "글 열람과 권한 변경이 사유와 함께 빠짐없이 남았나요?",
  "home.q.stats": "회사는 AI를 언제, 얼마나, 어떻게 쓰고 있나요?",
  "home.lead.team": "우리 팀이 AI를 얼마나, 어떻게 쓰는지 모아 봐요.",
  "home.lead.all": "회사 전체 사용량과 평소와 다른 곳을 함께 봐요.",
  "home.lead.ops": "기록이 빠짐없이 들어오는지 먼저 봐요.",
  "home.lead.audit": "글 열람과 권한 변경이 사유와 함께 남았는지 봐요.",
  "home.lead.stats": "회사가 AI를 언제, 얼마나, 어떻게 쓰는지 이름 없이 봐요.",
  "home.cli.sub": "AI 코딩 도구 Claude Code·Codex 사용, 결제 방식과 무관",
  "home.api.sub": "앱·스크립트가 회사 게이트웨이를 거쳐 부른 호출",
  "home.api.latA": "보통 {a}",
  "home.api.latB": "느릴 때 {b}",
  "home.cli.q": "CLI 도구로 얼마나 썼나요?",
  "home.cli.tech": "CLI 도구 · Claude Code · Codex",
  "home.cli.def": "AI 코딩 도구 Claude Code·Codex를 쓴 기록이에요. 결제 방식(구독 로그인·API 키)과 상관없이 여기에 모여요.",
  "home.cli.sum": "질문은 {s}",
  "home.cli.sumOnly": "질문 {n}을 보냈어요.",
  "home.m.activeClaude": "AI 사용 시간(Claude만)",
  "home.m.costCli": "도구 추정 비용",
  "home.m.calls": "호출 수",
  "home.m.costApi": "단가표 계산 비용",
  "home.m.latency": "응답 대기",
  "home.cli.auth": "결제 방식: 구독 로그인 {s} · API 키 {k} · 확인 안 됨 {u}",
  "home.cli.authNote": "대화 수 기준 · Claude는 기기마다 마지막으로 확인한 방식이에요",
  "home.cli.codex": "Codex",
  "home.cli.codexCost": "Codex",
  "home.cli.cache": "캐시에서 읽은 양이 {p}예요",
  "home.cli.noSum": "서로 더하지 않아요",
  "home.cli.gw": "CLI(게이트웨이 경유) {n}건 · 중복 확인 중",
  "home.cli.gwHelp": "CLI 도구가 회사 게이트웨이를 거쳐 부른 호출이에요. 같은 호출을 두 번 세지 않는지 확인하기 전까지 어느 카드에도 더하지 않아요.",
  "home.cli.emptyWhat": "이 기간에 받은 CLI 도구 기록이 없어요.",
  "home.cli.noConn": "아직 연결한 CLI 도구가 없어요.",
  "home.connect": "도구 연결하기",
  "home.tool.row": "질문 {p} · {tok}",
  "home.tool.rowApi": "호출 {c} · {tok}",
  "home.api.q": "API 키로 얼마나 불렀나요?",
  "home.api.tech": "API 키 호출 · 회사 게이트웨이",
  "home.api.def": "앱·스크립트가 회사 게이트웨이를 거쳐 AI를 부른 호출이에요. 게이트웨이를 거친 호출만 사람별로 보여요.",
  "home.api.sum": "호출은 {s}",
  "home.api.sumOnly": "호출 {n}을 보냈어요.",
  "home.api.latency": "보통 {a} · 느릴 때 {b}",
  "home.api.emptyWhat": "게이트웨이를 거친 API 키 호출 기록이 없어요.",
  "home.api.emptyNot": "게이트웨이를 거친 호출만 사람별로 보여요. API 키를 안 쓴 건 아닐 수 있어요.",
  "home.api.howTo": "앱 연결 방법",
  "home.api.org": "키 {k}개 · {days}일 · 사용량 {tok} · {usd}",
  "home.api.orgNote": "하루 단위 · 사람별 아님 · 위 숫자와 더하지 않아요",
  "home.daily.q": "날마다 얼마나 썼나요?",
  "home.daily.tech": "{metric} · 사용 방식별 누적 · 점선은 직전 기간",
  "home.daily.peak": "가장 많이 쓴 날은 {day}{ie}({v}).",
  "home.daily.peakHour": "가장 많이 쓴 때는 {day}{ie}({v}).",
  "home.daily.open": "누르면 이 기간의 사용 기록을 열어요",
  "home.opt.metric": "지표",
  "home.opt.periodHelp": "기간을 바꾸면 홈 전체 기간이 함께 바뀌어요.",
  "home.models.q": "어떤 AI 모델을 썼나요?",
  "home.models.tech": "AI 모델 · {metric} 비중 · 5개 넘으면 ‘기타’",
  "home.models.sum": "{model}{ga} 가장 많아요({p}).",
  "home.models.note": "CLI 도구·게이트웨이가 보낸 모델 이름이에요. AI의 중간 생각 글은 저장하지 않아요.",
  "home.heat.q": "언제 많이 쓰나요?",
  "home.heat.tech": "요일 × 시간 · 질문 보낸 시각(한국 시간)",
  "home.heat.sum": "{wd}요일 {h} 무렵에 가장 많이 물어봐요.",
  "home.heat.hidden": "사람이 3명보다 적어 시간대를 가렸어요.",
  "home.heat.unit": "질문",
  "home.recent.q": "최근에 어떤 대화를 했나요?",
  "home.recent.tech": "대화 · 최근 {n}건 · 누르면 기록 상세로 가요",
  "home.recent.all": "사용 기록 전체 보기",
  "home.recent.sum": "가장 최근 대화는 {rel}에 시작했어요.",
  "home.col.when": "시각",
  "home.col.title": "대화",
  "home.col.tool": "도구",
  "home.col.prompts": "질문",
  "home.col.tokens": "사용량",
  "home.col.active": "AI 사용 시간",
  "home.col.level": "기록 수준",
  "home.col.person": "사람",
  "home.conn.q": "내 도구 연결은 괜찮나요?",
  "home.conn.tech": "연결 상태 · 마지막 수신 기준",
  "home.conn.sumOk": "연결 {n}개가 모두 잘 보내고 있어요.",
  "home.conn.sumSome": "연결 {n}개 중 {bad}개를 살펴보세요.",
  "home.conn.none": "아직 연결한 도구가 없어요.",
  "home.conn.noneNot": "연결하기 전 기록은 남지 않아요. 연결하면 다음 질문부터 기록돼요.",
  "home.conn.last": "마지막 수신 {rel}",
  "home.conn.never": "받은 기록 없음",
  "home.conn.problem": "{tool} 연결에 오류가 있어요",
  "home.conn.check": "연결 확인",
  "home.team.active": "활성 인원",
  "home.team.activeOf": "팀원 {n}명 중",
  "home.team.costHint": "단가표 계산 {b}는 따로 · 서로 더하지 않아요",
  "home.team.members.q": "팀원별로 얼마나 쓰나요?",
  "home.team.members.tech": "{metric} · 이름순(순위 아님) · CLI 채움 / API 빗금",
  "home.team.members.sum": "팀원 {n}명 중 {a}명이 이 기간에 AI를 썼어요.",
  "home.team.members.former": "다른 팀으로 옮기기 전 기록이 있는 {n}명도 함께 보여요.",
  "home.team.mainTool": "주로 {tool}",
  "home.team.noUse": "이 기간 기록 없음",
  "home.team.moved": "{date}에 {team}{ro} 옮김 · 그 전 기록만",
  "home.team.excluded": "같은 팀의 다른 매니저·관리자·원문 열람 담당 기록은 보이지 않아요({n}명).",
  "home.team.noActive": "AI 사용 시간은 사람별로 보여 주지 않아요(팀 합계만).",
  "home.team.ratio.q": "CLI 도구와 API 키 호출은 어떤 비율인가요?",
  "home.team.ratio.tech": "사용 방식 비율 · CLI 채움 / API 빗금",
  "home.team.ratio.sum": "사용량의 {p}가 CLI 도구예요.",
  "home.team.ratio.tokens": "사용량(토큰)",
  "home.team.ratio.count": "질문·호출",
  "home.team.small.title": "소집단 보호가 켜져 있어요",
  "home.team.small.body": "조건에 남은 사람이 3명보다 적으면 시간대·사람별 값을 가려요(본인 기록은 예외). {team}{eun} 지금 {n}명이에요.",
  "home.team.small.more": "소집단 보호란?",
  "home.team.conn.q": "연결이 끊긴 팀원이 있나요?",
  "home.team.conn.tech": "연결 상태 · 지금 팀원 기준",
  "home.team.conn.sumNone": "팀원 {n}명의 연결이 모두 괜찮아요.",
  "home.team.conn.sum": "팀원 {n}명 중 {bad}명의 연결을 살펴보세요.",
  "home.team.conn.idleNote": "3일 넘게 받은 기록이 없으면 ‘연결 안 됨’이에요. 쓰지 않았다면 괜찮아요.",
  "home.org.activeUsers": "활성 사용자",
  "home.org.ofAll": "전체 {n}명 중",
  "home.org.todayPrompts": "오늘 질문",
  "home.org.todayHint": "오늘 0시부터 · 한국 시간",
  "home.org.errors": "오류·거절",
  "home.org.errorsHint": "요청 실패 {e}건 · 작업 거절 {r}건",
  "home.org.cost": "추정 비용",
  "home.org.costHint": "CLI 도구 추정 · 단가표 계산 {b}는 따로",
  "home.org.teams.q": "팀별로 얼마나 쓰나요?",
  "home.org.teams.tech": "사용량(토큰) · 이름순(순위 아님) · CLI 채움 / API 빗금",
  "home.org.teams.sum": "{n}개 팀에서 {u}명이 AI를 썼어요.",
  "home.org.teamRow": "{n}명 · 질문 {p}",
  "home.org.smallTeams": "소규모 팀 합산",
  "home.org.smallTeamsSub": "{t}개 팀 · {n}명 합산(3명보다 적은 팀)",
  "home.org.smallTeamsHidden": "3명보다 적은 팀 · 합쳐도 3명보다 적어 값을 가렸어요",
  "home.org.members.q": "이 팀 사람들은 얼마나 쓰나요?",
  "home.org.flow.q": "사용 방식·도구별로 어떻게 변했나요?",
  "home.org.flow.tech": "사용량(토큰) · 도구별 누적 영역 · CLI 채움 / API 빗금",
  "home.org.flow.sum": "{tool}{ga} 사용량의 {p}예요.",
  "home.org.anom.q": "평소와 다른 곳이 있나요?",
  "home.org.anom.tech": "이상 징후 · 급증 · 연결 · 대량 글 열람 · 수집 공백",
  "home.org.anom.sumNone": "지금 살펴볼 곳이 없어요.",
  "home.org.anom.sum": "살펴볼 곳이 {n}개 있어요.",
  "home.anom.spike": "{team} 사용량이 평소의 {r}배예요",
  "home.anom.spikeBody": "오늘 사용량이 최근 2주 평일 평균보다 크게 많아요. 다시 돌린 배치가 있는지 확인해 보세요.",
  "home.anom.down": "오류로 연결 안 됨 {n}개",
  "home.anom.idle": "3일 넘게 기록이 없는 연결 {n}개",
  "home.anom.idleBody": "쓰지 않았다면 괜찮아요. 기록 없음 ≠ 안 씀.",
  "home.anom.quiet": "한동안 조용한 연결 {n}개",
  "home.anom.quietBody": "4시간~3일 동안 받은 기록이 없어요.",
  "home.anom.bulk": "{who}{ga} 1시간 안에 글을 {n}건 열었어요",
  "home.anom.bulkCase": "조사 건 {id} 안의 열람이에요 · {from}~{to}",
  "home.anom.bulkNoCase": "조사 건 없이 연 열람이에요. 사유를 확인해 보세요.",
  "home.anom.gap": "수집 공백 {min}분 · {from}",
  "home.anom.go.stats": "통계에서 보기",
  "home.anom.go.system": "수집 상태 보기",
  "home.anom.go.audit": "열람·변경 이력 보기",
  "home.org.ingest.q": "기록이 빠짐없이 들어오나요?",
  "home.org.ingest.tech": "수집 상태 요약 · 최근 30일",
  "home.org.ingest.sum": "마지막 기록은 {rel}에 받았어요.",
  "home.org.received": "받은 기록",
  "home.org.dup": "중복(한 번만 셈)",
  "home.org.dropped": "규칙상 저장 안 함",
  "home.org.lastRx": "마지막 수신",
  "home.org.conn": "연결 상태",
  "home.org.gap": "수집 공백",
  "home.org.gapLine": "최근 7일 {n}번 · 가장 길게 {min}분",
  "home.org.org": "조직 보고서",
  "home.org.orgOk": "Anthropic 동기화 정상",
  "home.org.orgWarn": "OpenAI: {note}",
  "home.org.system": "수집 상태 보기",
  "home.setup.q": "초기 설정은 다 마쳤나요?",
  "home.setup.tech": "초기 설정 체크리스트 · 설치 직후 순서",
  "home.setup.sum": "{n}/{total}단계를 마쳤어요.",
  "home.setup.sumWarn": "{n}/{total}단계를 마쳤고, {w}개는 확인이 필요해요.",
  "home.setup.doneAt": "{date} 마침",
  "home.setup.warn": "확인 필요",
  "home.setup.todo": "아직 안 함",
  "home.ops.received": "오늘 받은 기록",
  "home.ops.connOk": "연결됨",
  "home.ops.connOkHint": "CLI 연결 {n}개 중",
  "home.ops.attention": "살펴볼 연결",
  "home.ops.attentionHint": "오류 {p} · 연결 안 됨 {d} · 조용함 {q}",
  "home.ops.errorRate": "요청 오류율",
  "home.ops.errorRateHint": "실패 {e}건 / 요청 {n}건",
  "home.ops.daily.q": "날마다 기록을 잘 받았나요?",
  "home.ops.daily.tech": "최근 14일 · 받음 · 규칙상 저장 안 함 · 중복",
  "home.ops.daily.sum": "오늘은 {n}건을 받았어요. {s}.",
  "home.ops.conn.q": "어느 연결을 살펴봐야 하나요?",
  "home.ops.conn.tech": "오류 · 연결 안 됨 · 한동안 조용함 · 마지막 수신 순",
  "home.ops.conn.sum": "오류가 있는 연결 {p}개부터 보세요.",
  "home.ops.col.user": "사람",
  "home.ops.col.device": "PC",
  "home.ops.col.tool": "도구",
  "home.ops.col.status": "상태",
  "home.ops.col.last": "마지막 수신",
  "home.ops.col.why": "이유",
  "home.ops.unknown.q": "모르는 기록 이름이 들어왔나요?",
  "home.ops.unknown.tech": "이름·건수만 세요(저장 안 함)",
  "home.ops.unknown.sum": "모르는 이름 {n}개가 들어왔어요. 지원표에 넣을지 확인하세요.",
  "home.ops.noContent": "운영 담당은 질문·답변 글을 볼 수 없어요. 합계와 수집 상태만 보여요.",
  "home.aud.views": "글 열람",
  "home.aud.viewsHint": "성공 {s} · 거부 {d}",
  "home.aud.integrity": "위변조 검사",
  "home.aud.ok": "정상",
  "home.aud.okHint": "이력 {n}건 · 고정점 {date}",
  "home.aud.bad": "끊김",
  "home.aud.badHint": "{id}에서 연결이 끊겼어요",
  "home.aud.bulk": "대량 열람 경보",
  "home.aud.bulkHint": "1시간 안에 5건 이상 · 최근 2일",
  "home.aud.list.q": "최근 누가 무엇을 보고 바꿨나요?",
  "home.aud.list.tech": "열람·변경 이력 · 최근 {n}건 · 고치거나 지울 수 없어요",
  "home.aud.list.sum": "최근 {n}건 중 거부가 {d}건이에요.",
  "home.aud.col.when": "시각",
  "home.aud.col.kind": "무엇을",
  "home.aud.col.actor": "누가(역할)",
  "home.aud.col.target": "대상",
  "home.aud.col.cat": "사유 범주",
  "home.aud.col.result": "결과",
  "home.aud.conv": "대화 #{no}",
  "home.task.q": "처리할 열람 일이 있나요?",
  "home.task.tech": "2인 승인 · 조사 건 · 내 열람 허가",
  "home.task.sum": "승인을 기다리는 요청이 {n}건 있어요.",
  "home.task.sumNone": "지금 처리할 승인 요청이 없어요.",
  "home.task.apr": "{who}에게 ‘{perm}’({scope}) 권한을 주는 요청",
  "home.task.aprMeta": "{id} · 요청 {req} · {date} · {until}까지",
  "home.task.approve": "승인",
  "home.task.reject": "거절",
  "home.task.approved": "승인했어요. 열람·변경 이력에 남았어요.",
  "home.task.rejected": "거절했어요. 열람·변경 이력에 남았어요.",
  "home.task.confirmTitle": "이 요청을 승인할까요?",
  "home.task.confirmBody": "요청한 사람과 승인하는 사람은 달라야 해요(2인 승인). 승인하면 안내문 문구가 바뀌고 당사자에게 알려요.",
  "home.task.case": "진행 중인 조사 건",
  "home.task.caseMeta": "{id} · 대상 {n}명 · {to}까지 · 열람 {v}건",
  "home.task.grants": "내 열람 허가",
  "home.task.grantsNone": "지금 열려 있는 허가가 없어요.",
  "home.task.grantLeft": "대화 #{no} · {min}분 남음",
  "home.task.statusDone": "처리됨",
};

export default home;
